import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Switch } from "antd";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import TableAntd from "components/elements/Table";

const AdminList = () => {
  const { t } = useTranslation();
  const mockData = [
    {
      key: "1",
      adminId: 1,

    },
  ];
  //    const [useFilter, setUseFilter] = useState(false);

  //   const handleStatusChange = (checked, recordKey) => {
  //     const updatedData = data.map((item) =>
  //       item.key === recordKey
  //         ? { ...item, statusFlag: checked ? "ACTIVE" : "INACTIVE" }
  //         : item
  //     );
  //     setData(updatedData);
  //   };

  const columns = [
    {
      title: <div className="text-table">{t("admin_setting.label.admin_id")}</div>,
      dataIndex: "adminId",
      key: "adminId",
      width: 150,
      render: (text) => (
        <div
          style={{
            color: "#42526D",
            backgroundColor: "#F5F6F7",
            borderRadius: "20px",
            width: "max-content",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            padding: "8px 16px"
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: <div className="text-table">{t("signup.input.name")}</div>,
      dataIndex: "name",
      key: "name",
    },
    {
      title: <div className="text-table">{t("signup.input.email")}</div>,
      dataIndex: "email",
      key: "email",
    },
    {
      title: <div className="text-table">{t("user_management.label.role")}</div>,
      dataIndex: "role",
      key: "role",
    },
    {
      title: <div className="text-table">{t("companytake.compant_take")}</div>,
      dataIndex: "company",
      key: "company",
    },
    {
      title: (
        <div style={{ color: "#667085" }} className="text-table">
          {t("master_data.label.status")}
        </div>
      ),
      dataIndex: "statusFlag",
      key: "statusFlag",
      width: 100,
      render: (text, record) => (
        <Switch
        //   checked={text === "ACTIVE"}
        //   onChange={(checked) => handleStatusChange(checked, record.key)}
        />
      ),
    },
    {
      title: <div className="text-table">{t("admin_setting.label.last_login")}</div>,
      dataIndex: "lastLogin",
      key: "lastLogin",
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: () => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: t("action.edit"),
                icon: <EditOutlined style={{ fontSize: "18px", color: "gray" }} />,
              },
              {
                key: "2",
                label: t("action.delete"),
                icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
              },
            ],
          }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <MoreOutlined
            style={{ fontSize: "20px", color: "gray", cursor: "pointer" }}
          />
        </Dropdown>
      ),
    },
  ];

  return <TableAntd columns={columns} pagination={{ pageSize: 10 }} />;
};

export default AdminList;
